// Apenas metadados: arquivos e conteúdo dos documentos não vão para o storage.
const chaveUsuario = (userId) => `sear:solicitacoes-processo:${userId}`;
const lerJSON = (chave) => {
  const valor = sessionStorage.getItem(chave);
  return valor ? JSON.parse(valor) : null;
};
const combinacao = (dados) => JSON.stringify([
  String(dados.processType), String(dados.selectedSchool || 'todas'),
]);

export function lerSolicitacaoAtiva(userId) {
  if (!userId) return null;
  const ativa = lerJSON('processData');
  if (ativa?.userId && String(ativa.userId) !== String(userId)) return null;
  return ativa;
}

export function prepararSolicitacao(userId, dados) {
  if (!userId) throw new Error('Sua sessão não foi carregada. Tente novamente.');
  const tentativas = lerJSON(chaveUsuario(userId)) || {};
  const ativa = lerSolicitacaoAtiva(userId);
  const anterior = tentativas[combinacao(dados)] ||
    (ativa && combinacao(ativa) === combinacao(dados) ? ativa : null);
  const chaveSolicitacao = anterior?.chaveSolicitacao || window.crypto?.randomUUID?.();
  if (!chaveSolicitacao) throw new Error('Não foi possível identificar a solicitação.');
  const solicitacao = { ...dados, userId, chaveSolicitacao,
    criadoEm: anterior?.criadoEm || new Date().toISOString(),
    envioIniciado: anterior?.envioIniciado === true };
  // Preserva a tentativa anterior antes de trocar a seleção ativa.
  if (ativa?.chaveSolicitacao) tentativas[combinacao(ativa)] = { ...ativa, userId };
  tentativas[combinacao(dados)] = solicitacao;
  sessionStorage.setItem(chaveUsuario(userId), JSON.stringify(tentativas));
  sessionStorage.setItem('processData', JSON.stringify(solicitacao));
  return solicitacao;
}

export function marcarEnvio(solicitacao) {
  const atualizada = { ...solicitacao, envioIniciado: true };
  const tentativas = lerJSON(chaveUsuario(solicitacao.userId)) || {};
  tentativas[combinacao(atualizada)] = atualizada;
  sessionStorage.setItem(chaveUsuario(solicitacao.userId), JSON.stringify(tentativas));
  sessionStorage.setItem('processData', JSON.stringify(atualizada));
  return atualizada;
}

export function concluirSolicitacao(solicitacao) {
  const tentativas = lerJSON(chaveUsuario(solicitacao.userId)) || {};
  const item = tentativas[combinacao(solicitacao)];
  if (item?.chaveSolicitacao === solicitacao.chaveSolicitacao) {
    delete tentativas[combinacao(solicitacao)];
    sessionStorage.setItem(chaveUsuario(solicitacao.userId), JSON.stringify(tentativas));
  }
  if (lerSolicitacaoAtiva(solicitacao.userId)?.chaveSolicitacao === solicitacao.chaveSolicitacao) {
    sessionStorage.removeItem('processData');
  }
}
